<template>
  <div :style="zoneStyle">
    <v-snackbar top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>

    <div class="header" :style="headerHeight">
      <h2>Editor de zonas</h2>

      <v-select
        v-model="selectedAspect"
        :items="aspect"
        item-text="text"
        :loading="loading"
        style="max-width:200px"
        item-value="value"
        label="Relación de aspecto"
      ></v-select>

      <v-select
        v-model="selectedGrid"
        :items="grid"
        item-text="text"
        :loading="loading"
        style="max-width:200px"
        item-value="value"
        label="Cuadrícula"
      ></v-select>

      <v-btn class="close" icon dark @click="$emit('cancel')">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </div>
    <div :style="bodyHeight">
      <div class="actions">
        <v-text-field
          v-model="name"
          label="Nombre de la zona"
          clearable
          :loading="loading"
          autofocus
          rounded
          filled
        ></v-text-field>
        <!-- <v-select
          v-model="selectedAspect"
          :items="aspect"
          item-text="text"
          :loading="loading"
          rounded
          filled
          item-value="value"
          label="Relación de aspecto"
        ></v-select> -->
        <v-list>
          <v-subheader>Componentes</v-subheader>
          <v-list-item-group color="primary">
            <v-list-item
              :disabled="!item.active"
              v-for="(item, i) in items"
              @click="addComponent(item)"
              :key="i"
            >
              <v-list-item-icon>
                <v-icon
                  style="font-size: 20px !important"
                  class="pt-2 pr-5"
                  v-text="item.icon"
                >
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.text"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-col cols="12" sm="12" md="12">
          <v-btn
            :loading="loading"
            block
            color="btn-color"
            :elevation="0"
            @click="originalItem ? update() : save()"
            class="flex-grow-1 flex-shrink-0 white--text mt-5"
            :minHeight="56"
          >
            Guardar
          </v-btn>
        </v-col>
      </div>
      <div id="workArea" class="main-zone" :style="workArea">
        <vue-draggable-resizable
          :w="item.width"
          :h="item.height"
          :x="item.x"
          :y="item.y"
          :style="`background-color:black`"
          v-for="(item, index) of zones"
          :key="index"
          class="item-added"
          class-name-dragging="dragging"
          class-name-active="item-active"
          class-name-resizing="resizing"
          @dragging="onDrag"
          @activated="activateZone(index)"
          @resizing="onResize"
          :parent="true"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <div
                v-on:dblclick="(counter += 1), editComponent(item, index)"
                class="cont-item"
                v-on="on"
              >
                <player
                  v-if="item.type == 'player'"
                  :width="item.width"
                  :height="item.height"
                  :adjustment="item.adjustment"
                  :playlistId="item.playlist"
                />
                <marquee
                  :dimensions="dimensions"
                  v-if="item.type == 'marquee'"
                  :item="item"
                />
                <notices
                  :dimensions="dimensions"
                  v-if="item.type == 'notices'"
                  :item="item"
                />
                <first-time-template
                  v-if="item.type == 'time'"
                  :dimensions="dimensions"
                  :width="item.width"
                  :height="item.height"
                  :configuration="item.configuration"
                />
              </div>
            </template>
            <span>Doble clic para editar</span>
          </v-tooltip>
        </vue-draggable-resizable>
      </div>
    </div>

    <v-dialog
      v-if="componentDialog"
      persistent
      :max-width="selectedComponent == 'time' ? '80%' : '700px'"
      v-model="componentDialog"
    >
      <new-component
        :dimensions="dimensions"
        @updated="handleUpdate"
        :selectedItem="selectedItem"
        @success="added"
        :type="selectedComponent"
        @cancel="componentDialog = false"
      />
    </v-dialog>

    <vue-draggable-resizable
      :resizable="false"
      :w="230"
      :h="430"
      class="details"
      v-if="showDetails"
      :parent="true"
    >
      <i @click="showDetails = false" class="fas fa-times close-details"></i>
      <span>{{ zones[selectedZone].name }}</span>
      <v-text-field
        label="Ancho"
        v-model.number="zones[selectedZone].width"
        class="mt-3"
        rounded
        type="number"
        filled
        persistent-hint
        :hint="`${(
          (zones[selectedZone].width / dimensions.width) *
          100
        ).toFixed(1)}% del ancho.`"
      ></v-text-field>

      <v-text-field
        label="Alto"
        rounded
        v-model.number="zones[selectedZone].height"
        :hint="`${(
          (zones[selectedZone].height / dimensions.height) *
          100
        ).toFixed(1)}% del alto`"
        persistent-hint
        type="number"
        filled
      ></v-text-field>

      <v-text-field
        :value="`${((zones[selectedZone].x / dimensions.width) * 100).toFixed(
          1
        )}%`"
        label="Posición inicial X"
        rounded
        disabled
        filled
      ></v-text-field>

      <v-text-field
        :value="`${((zones[selectedZone].y / dimensions.height) * 100).toFixed(
          1
        )}%`"
        label="Posición inicial Y"
        rounded
        disabled
        filled
      ></v-text-field>

      <v-btn
        class="flex-grow-1 flex-shrink-0 white--text"
        large
        rounded
        :elevation="0"
        @click="remove(selectedZone)"
        :minHeight="36"
        block
        color="red darken-4"
      >
        Eliminar
      </v-btn>
    </vue-draggable-resizable>
  </div>
</template>

<script>
import { db, fb } from "@/firebase";
import { mapActions, mapState } from "vuex";
import VueDraggableResizable from "vue-draggable-resizable";
import newComponent from "./new-component";
import player from "./components/player";
import Player from "./components/player.vue";
import marquee from "./components/marquee";
import notices from "./components/notices";
import firstTimeTemplate from "./components/time/template1";

export default {
  name: "new-zone",
  props: ["originalItem"],
  components: {
    VueDraggableResizable,
    newComponent,
    player,
    marquee,
    notices,
    firstTimeTemplate,
  },
  data() {
    return {
      snackbarText: "",
      snackbar: false,
      loading: true,
      showDetails: false,
      counter: 0,
      name: "",
      dimensions: null,
      selectedItem: null,
      selectedAspect: 2,
      selectedZone: null,
      selectedComponent: null,
      componentDialog: false,
      selectedGrid : 10,
      zones: [],
      items: [
        {
          text: "Avisos",
          icon: "fas fa-newspaper",
          type: "notices",
          active: true,
        },
        {
          text: "Cinta informativa",
          icon: "fas fa-tags",
          type: "marquee",
          active: true,
        },
        {
          text: "Reproductor multimedia",
          icon: "fas fa-play-circle",
          type: "player",
          active: true,
        },
        {
          text: "Clima",
          icon: "fas fa-cloud-moon-rain",
          type: "weather",
          active: false,
        },
        {
          text: "Fecha",
          icon: "fas fa-calendar-alt",
          type: "date",
          active: false,
        },
        { text: "Hora", icon: "fas fa-clock", type: "time", active: false },
      ],
      aspect: [
        { text: "4:3", value: 0 },
        { text: "5:4", value: 1 },
        { text: "16:9", value: 2 },
        { text: "16:10", value: 3 },
      ],
       grid: [
        { text: "2x2", value: 2 },
        { text: "3x3", value: 3 },
        { text: "4x4", value: 4 },
        { text: "5x5", value: 5 },
        { text: "6x6", value: 6 },
        { text: "7x7", value: 7 },
        { text: "8x8", value: 8 },
        { text: "9x9", value: 9 },
        { text: "10x10", value: 10 },
      ],
    };
  },
  computed: {
    ...mapState(["user", "userDoc", "groupId"]),
    zoneStyle() {
      return `width : ${document.getElementById("app").clientWidth}px;
        background-color:white;
        padding-right:10px;
        overflow-y:scroll`;
    },
    headerHeight() {
      return `height : ${
        document.getElementById("app").clientHeight * 0.08
      }px; padding:10px`;
    },
    bodyHeight() {
      return {
        height: `${document.getElementById("app").clientHeight * 0.92}px`,
        display: "flex",
        "justify-content": "space-around",
      };
    },
    workArea() {
      let availableWidth = document.getElementById("app").clientWidth - 310;
      let availableHeight =
        document.getElementById("app").clientHeight * 0.92 - 20;
      let height = null;

      switch (this.selectedAspect) {
        case 0:
          //4/3 1.33333333333
          height = (availableWidth * 3) / 4;
          break;
        case 1:
          // 5/4 1.25
          height = (availableWidth * 4) / 5;
          break;
        case 2:
          // 16/9  1.777777777777
          height = (availableWidth * 9) / 16;
          break;
        case 3:
          //16/10 1.6
          height = (availableWidth * 10) / 16;
          break;
      }

      return {
        width: `${availableWidth}px`,
        height: `${height}px`,
        "background-size": `${availableWidth / this.selectedGrid}px ${height / this.selectedGrid}px, ${
          availableWidth / this.selectedGrid
        }px ${height / this.selectedGrid}px`,
      };
    },
    numericSize() {
      let availableWidth = document.getElementById("app").clientWidth - 310;
      let availableHeight =
        document.getElementById("app").clientHeight * 0.92 - 20;
      let height = null;

      switch (this.selectedAspect) {
        case 0:
          //4/3 1.33333333333
          height = (availableWidth * 3) / 4;
          break;
        case 1:
          // 5/4 1.25
          height = (availableWidth * 4) / 5;
          break;
        case 2:
          // 16/9  1.777777777777
          height = (availableWidth * 9) / 16;
          break;
        case 3:
          //16/10 1.6
          height = (availableWidth * 10) / 16;
          break;
      }
      return { width: availableWidth, height };
    },
  },

  methods: {
    remove(index) {
      this.showDetails = false;
      this.zones.splice(index, 1);
    },
    activateZone(index) {
      this.selectedZone = index;
      this.showDetails = true;
    },
    editComponent(item, index) {
      this.counter = 0;
      this.selectedComponent = item.type;
      this.selectedItem = {
        data: item,
        index,
      };
      this.componentDialog = true;
    },

    handleUpdate(data) {
      this.zones[this.selectedItem.index] = data;
      this.componentDialog = false;
    },

    added(data) {
      this.componentDialog = false;
      this.zones.push(data);
    },

    addComponent(item) {
      this.selectedItem = null;
      this.selectedComponent = item.type;
      this.componentDialog = true;
    },
    onResize: function (x, y, width, height) {
      this.zones[this.selectedZone].x = x;
      this.zones[this.selectedZone].y = y;
      this.zones[this.selectedZone].width = width;
      this.zones[this.selectedZone].height = height;
    },
    onDrag: function (x, y) {
      this.zones[this.selectedZone].x = x;
      this.zones[this.selectedZone].y = y;
    },
    update() {
      let { width, height } = this.numericSize;
      let items = JSON.parse(JSON.stringify(this.zones));

      items = items.map((item) => {
        let zone = item;
        zone.width = Number.parseFloat(((zone.width / width) * 100).toFixed(1));
        zone.height = Number.parseFloat(
          ((zone.height / height) * 100).toFixed(1)
        );
        zone.x = Number.parseFloat(((zone.x / width) * 100).toFixed(1));
        zone.y = Number.parseFloat(((zone.y / height) * 100).toFixed(1));
        return zone;
      });

      if (this.name && items.length > 0) {
        this.loading = true;
        db.collection("zones")
          .doc(this.originalItem[".key"])
          .update({
            name: this.name,
            aspect: this.selectedAspect,
            components: items,
            modifiedBy: this.user.uid,
            modifiedAt: new Date(),
          })
          .then((response) => {
            this.$emit("success");
          })
          .catch((err) => {
            this.loading = false;
            this.snackbarText =
              "Ocurrió un error inesperado, inténtelo nuevamente.";
            this.snackbar = true;
          });
      } else {
        this.snackbarText = "Ingrese el nombre de la zona.";
        this.snackbar = true;
      }
    },
    save() {
      let { width, height } = this.numericSize;
      let items = JSON.parse(JSON.stringify(this.zones));

      items = items.map((item) => {
        let zone = item;
        zone.width = Number.parseFloat((zone.width / width) * 100);
        zone.height = Number.parseFloat((zone.height / height) * 100);
        zone.x = Number.parseFloat((zone.x / width) * 100);
        zone.y = Number.parseFloat((zone.y / height) * 100);
        return zone;
      });

      if (this.name && items.length > 0) {
        this.loading = true;
        db.collection("zones")
          .add({
            name: this.name,
            aspect: this.selectedAspect,
            components: items,
            createdBy: this.user.uid,
            createdAt: new Date(),
            groupId: this.groupId,
          })
          .then((response) => {
            this.$emit("success");
          })
          .catch((err) => {
            this.loading = false;
            this.snackbarText =
              "Ocurrió un error inesperado, inténtelo nuevamente.";
            this.snackbar = true;
          });
      } else {
        this.snackbarText = "Ingrese el nombre de la zona.";
        this.snackbar = true;
      }
    },
  },
  mounted() {
    this.dimensions = this.numericSize;
    if (this.originalItem) {
      this.name = this.originalItem.name;
      this.selectedAspect = this.originalItem.aspect;

      this.zones = JSON.parse(JSON.stringify(this.originalItem.components));

      this.zones.forEach((item) => {
        item.width = Number.parseFloat(
          (item.width / 100) * this.dimensions.width
        );
        item.height = Number.parseFloat(
          (item.height / 100) * this.dimensions.height
        );
        item.x = Number.parseFloat((item.x / 100) * this.dimensions.width);
        item.y = Number.parseFloat((item.y / 100) * this.dimensions.height);
      });
    }
    this.loading = false;
  },
};
</script>

<style scoped>
.main-zone {
  background-color: rgb(212, 212, 212);
  border: 1px solid rgba(0, 0, 0, 0.4);
  overflow: hidden !important;
  background-image: linear-gradient(
      -90deg,
      rgba(36, 36, 36, 0.4) 1px,
      transparent 0
    ),
    linear-gradient(rgba(48, 48, 48, 0.4) 1px, transparent 0);
  background-position: 0 0;
  background-repeat: repeat, repeat;
  background-attachment: scroll, scroll;
}
/* .main-cont {
  justify-content: center;
  display: flex;
} */

.item-added {
  background-color: white;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  display: flex;
  position: absolute;
  z-index: 9999;
  justify-items: center;
  min-height: 20px;
  min-width: 20px;
}

.dragging {
  opacity: 0.4;
  border: 1px solid red !important;
  z-index: 10000 !important;
}

.resizing {
  opacity: 0.4;
  border: 1px solid red !important;
}

.border-left-limit {
  border-left: 1px solid red !important;
}
.border-right-limit {
  border-right: 1px solid red !important;
}
.border-top-limit {
  border-top: 1px solid red !important;
}
.border-bottom-limit {
  border-bottom: 1px solid red !important;
}

.item-active {
  z-index: 9999 !important;
}

.remove {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 20px !important;
  cursor: pointer;
  font-weight: bold;
}

.cont-item {
  width: 100%;
  height: 100%;
}

.details {
  padding: 20px;
  background-color: rgb(255, 255, 255);
  position: fixed;
  top: 20px;
  left: 15px;
  border-radius: 10px;
  -webkit-box-shadow: 5px 5px 15px 0px #000000;
  box-shadow: 5px 5px 15px 0px #000000;
  z-index: 999;
  cursor: move;
}

.close-details {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  color: gray;
  font-size: 20px;
}

.zones-editor {
  width: 100vw;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  /* background-color: #b99090; */
}

.close i {
  color: dimgrey !important;
  font-size: 20px !important;
  padding: 5px;
}

.actions {
  padding: 20px;
  width: 300px;
}

.header {
  display: grid;
  grid-template-columns: 300px auto auto auto auto
}
</style>